import React from "react";
import styled from "styled-components"
import Home from "./Components/Home"
import AboutUs from "./Components/About Us";
import Products from "./Components/Products";
import ContactUs from "./Components/ContactUs";
import Header from "./Components/Header";
import Footer from "./Components/Footer"
import { ThemeProvider } from "styled-components";
import {BrowserRouter,Routes,Route} from "react-router-dom"
import ProductPage from "./Components/ProductPage"; // Import karna na bhoolo


const MainContainer = styled.div`
padding:0%;
margin:0%;
box-sizing: border-box;
`

function App() {
  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgb(24 24 29)",
      white: "#fff",
      black: " #212529",
      helper: "#8490ff",
      bg: "rgb(249 249 255)",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98, 84, 243, 0.5)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: { mobile: "768px", tab: "998px" },
  };
  return (
    <>
    <ThemeProvider theme={theme}></ThemeProvider>
     <MainContainer>
      <BrowserRouter>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/products" element={<Products/>}/>
        <Route path="/aboutus" element={<AboutUs/>}/>
        <Route path="/contactus" element={<ContactUs/>}/>
        <Route path="/product/:id" element={<ProductPage />} />
        
        


      </Routes>
      <Footer/>
      </BrowserRouter>

     </MainContainer>
       
      
    </>
  );
}

export default App;
